/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Noaccessofferings3Inputs */

const en_usermanagement_permissions_noaccessofferings3 = /** @type {(inputs: Usermanagement_Permissions_Noaccessofferings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't currently have access to offerings`)
};

/**
* | output |
* | --- |
* | "You don't currently have access to offerings" |
*
* @param {Usermanagement_Permissions_Noaccessofferings3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_noaccessofferings3 = /** @type {((inputs?: Usermanagement_Permissions_Noaccessofferings3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Noaccessofferings3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_noaccessofferings3(inputs)
});
export { usermanagement_permissions_noaccessofferings3 as "userManagement_permissions_noAccessOfferings" }